import lang from '@/lang'
import DateUtils from '@/utils/dateUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import {
  existWorkflowGroup,
  getByDocumentProcessId,
  isBpmEnabled,
  workflowActionBatch,
  workflowHistory
} from '@/api/workflow'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import {
  APPLICATION_DIMENSION_BILL,
  BILL_PAYMENT, CHARGE_CHANGE, COLLECT_INVOICE,
  Job_CHARGE,
  MAKE_INVOICE, MAKE_INVOICE_INTERNAL_INVOICE, POSITION_CASTS,
  WORKFLOW_DISCARD
} from '@/class/cargo/model/parameters/WorkflowConstants'
import { getLoading } from '@/utils/utilBaseElement'
import { getUserInfo } from '@/utils/auth'
import { queryBillPaymentDetail } from '@/api/clearing/billPayment'
import { getInvoiceDetails } from '@/api/clearing/invoice'
import StrUtils from '@/utils/StrUtils'
import { getWorkFlowChangeCharge } from '@/api/clearing/changeChargeBpm'
import $store from '@/store'

/**
 * 审批流程工具类
 */
export class WorkflowUtil {
  /**
   * 获取审核动作名称
   * @param actionType
   * @returns {*}
   */
  static getActionName(actionType) {
    if (actionType === 7000) {
      return lang.t('CargoMsg.Cargo_Committed')
    }
    if (actionType === 7001) {
      return lang.t('CargoMsg.Cargo_Agreed')
    }
    if (actionType === 7002) {
      return lang.t('CargoMsg.Cargo_Denied')
    }
    if (actionType === 7003) {
      return lang.t('CargoMsg.Cargo_ReviewWithdrawal')
    }
    if (actionType === 7004) {
      return lang.t('CargoMsg.Cargo_ProcessRevocation')
    }
    if (actionType === 7006) {
      return lang.t('CargoMsg.Cargo_ReturnToTheInitiatingNode')
    }
    if (actionType === 7007) {
      return lang.t('CargoMsg.Cargo_AutoAgree')
    }
    if (actionType === 7008) {
      return lang.t('CargoMsg.Cargo_PressToDo')
    }
    if (actionType === 7009) {
      return lang.t('CargoMsg.Cargo_Deleted')
    }
    if (actionType === 7010) {
      return lang.t('CargoMsg.Cargo_Canceled')
    }
    if (actionType === 7011) {
      return lang.t('CargoMsg.Cargo_AddSignature')
    }
    if (actionType === 7012) {
      return lang.t('CargoMsg.Cargo_TransferSignature')
    }
    if (actionType === 7013) {
      return lang.t('CargoMsg.Cargo_Appointed')
    }
    if (actionType === 7014) {
      return lang.t('CargoMsg.Cargo_CancelSignature')
    }
  }

  /**
   * 修改查询条件
   * @param params
   */
  static changeFilter(params) {
    this.changeDateFilter(params)
    if (params.workflowName) {
      params.workflowName = params.workflowName.trim()
    }
    if (params.documentProcessNo) {
      params.documentProcessNo = params.documentProcessNo.trim()
    }
  }

  /**
   * 修改日期的查询条件
   * @param params
   */
  static changeDateFilter(params) {
    if (params.startDate) {
      params.createBeginDate = params.startDate[0]
      params.createEndDate = DateUtils.formatStandardMinuteTime(DateUtils.strDateToTimestamp(params.startDate[1]) + 24 * 60 * 60 * 1000 - 1)
    } else {
      delete params.createBeginDate
      delete params.createEndDate
    }
    if (params.lastModified) {
      params.lastModifiedBeginDate = params.lastModified[0]
      params.lastModifiedEndDate = DateUtils.formatStandardMinuteTime(DateUtils.strDateToTimestamp(params.lastModified[1]) + 24 * 60 * 60 * 1000 - 1)
    } else {
      delete params.lastModifiedBeginDate
      delete params.lastModifiedEndDate
    }
  }

  /**
   * 文件大小转换
   * @param fileSize
   * @returns {string}
   */
  static fileSizeLabel(fileSize) {
    const size = fileSize ? (NumberUtils.formatNumber(Number(fileSize) / 1024, 2) + 'KB') : '0KB'
    return '(' + size + ')'
  }

  static async isBpmEnabled(params) {
    try {
      const currentUserInfo = getUserInfo()
      var key = `bpmEnabled_${currentUserInfo.tenantId}_${params.documentConfigId}_${params.officeId}`
      if (params.formSubtype !== undefined && params.formSubtype !== null) {
        key = `bpmEnabled_${currentUserInfo.tenantId}_${params.documentConfigId}_${params.formSubtype}_${params.officeId}`
      }
      const bpmEnabled = localStorage.getItem(key)
      if (bpmEnabled !== undefined && bpmEnabled !== null) {
        return bpmEnabled === 'true'
      } else {
        const res = await isBpmEnabled(params)
        localStorage.setItem(key, res.data)
        return res.data
      }
    } catch (e) {

    }
  }

  // CARGO-32805 BPM流程引擎二期，提交
  static async jobSubmitBpm(view, operateNameCode, isProfitPrint, config, job) {
    if (isProfitPrint === null) {
      if (operateNameCode === SystemConstants.OPERATE_SUBMISSION.code &&
          await this.isBpmEnabled({ documentConfigId: Job_CHARGE.code, officeId: job.opOffice })) {
        const msg = view.$t('CargoMsg.Cargo_SubmitJobChargeTip')
        view.$confirm(msg, view.$t('common.tips.prompt'), {
          confirmButtonText: view.$t('common.btn.ok'),
          cancelButtonText: view.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(async() => {
          view.jobApplyDialog.visible = true
        }).catch(() => {
        })
        return true
      }
      return false
    } else {
      if ((operateNameCode === SystemConstants.OPERATE_SUBMISSION.code ||
          (isProfitPrint && Number(config.get('PrintProfitToPreCommit')) === 2 && (job.jobState === SystemConstants.PRE_COMMIT || job.jobState === SystemConstants.OPERATING))) &&
          await this.isBpmEnabled({ documentConfigId: Job_CHARGE.code, officeId: job.opOffice })) {
        const msg = view.$t('CargoMsg.Cargo_SubmitJobChargeTip')
        view.$confirm(msg, view.$t('common.tips.prompt'), {
          confirmButtonText: view.$t('common.btn.ok'),
          cancelButtonText: view.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(async() => {
          view.jobApplyDialog.visible = true
        }).catch(() => {
        })
        return true
      }
      return false
    }
  }
  // CARGO-32805 BPM流程引擎二期，批量提交
  static jobBatchCommitBpm(view, params) {
    view.loading = getLoading()
    workflowActionBatch(params).then(res => {
      if (!res.data || res.data.length === 0) {
        view.$message.success(view.$t('SeaExport.Submission') + view.$t('CargoMsg.Cargo_ApprovedSuccess'))
      } else {
        view.batchSubmitOrApproveDialog.visible = true
        view.batchSubmitOrApproveDialog.rowData = res.data
      }
      view.loading.close()
      view.toQuery()
    }).catch(() => {
      view.loading.close()
    }).finally(() => {
      view.loading.close()
    })
  }
  // CARGO-39771 BPM各审批流增加快捷入口（显示审批弹窗）
  static async showWorkFlowApplyDialog(view, workFlowApplyDialog, workFlowApplyDialogRefName, documentProcessId) {
    view.loading = getLoading()

    try {
      // 加载 单据基本信息
      await getByDocumentProcessId(documentProcessId).then(res => {
        workFlowApplyDialog.documentProcess = res.data
      })

      const documentProcess = workFlowApplyDialog.documentProcess

      if (WORKFLOW_DISCARD.code === documentProcess.state) {
        return
      }

      // 加载 单据审批记录信息
      workflowHistory({ documentProcessId: documentProcessId }).then(res => {
        workFlowApplyDialog.approvalCommentsRecords = res.data.traces.filter(trace => [7008, 7011, 7012, 7013, 7014].indexOf(trace.actionType) === -1)
      })

      if (BILL_PAYMENT.code === documentProcess.documentConfigId) {
        queryBillPaymentDetail({
          billPaymentUuid: documentProcess.docId,
          paging: false,
          requires: 'accountPeriodRemainingDays'
        }).then(res => {
          workFlowApplyDialog.billPayment = res.data
          workFlowApplyDialog.visible = true
        })
      } else if (Job_CHARGE.code === documentProcess.documentConfigId) {
        workFlowApplyDialog.visible = true
      } else if (MAKE_INVOICE.code === documentProcess.documentConfigId) {
        if (APPLICATION_DIMENSION_BILL.code === documentProcess.applicationDimension) {
          // 账单编号 维度（开票单据）
          workFlowApplyDialog.visible = true
        } else {
          // 发票ID 维度（开票单据）
          const requestBody = { 'keys': [documentProcess.docId] }
          getInvoiceDetails(requestBody).then(async res => {
            console.log('getInvoiceDetails', res)
            const invoiceProperties = workFlowApplyDialog.invoiceProperties
            invoiceProperties.invoices = res.data
            invoiceProperties.currentPage = 1
            invoiceProperties.totalPage = 1
            invoiceProperties.invoice = invoiceProperties.invoices[0]
            // 增票合并/显示明细
            if (invoiceProperties.invoice.ar && [2, 3].includes(invoiceProperties.invoice.invoiceType)) {
              invoiceProperties.rbgShowChargeDetail = 'merge'
              for (const invoiceItem of invoiceProperties.invoice.invoiceItemList) {
                if (invoiceItem.goodsName.indexOf('\n') > -1) {
                  invoiceProperties.rbgShowChargeDetail = 'detail'
                }
              }
            } else if (invoiceProperties.invoice.ar && [0, 1, 4].includes(invoiceProperties.invoice.invoiceType)) {
              invoiceProperties.rbgShowChargeDetail = 'merge'
              if (!StrUtils.isEmpty(invoiceProperties.invoice.partAmount) && invoiceProperties.invoice.partAmount.indexOf('\n') > -1) {
                invoiceProperties.rbgShowChargeDetail = 'detail'
              }
            }
            try {
              await existWorkflowGroup({
                officeId: this.$store.getters.currentOfficeId,
                formSubtype: MAKE_INVOICE_INTERNAL_INVOICE.code
              }).then(async res => {
                invoiceProperties.invoiceTriggerBpm = res.data
              })
            } catch (e) {
              // error
            }
            workFlowApplyDialog.visible = true
            view.$nextTick(() => {
              view.$refs[workFlowApplyDialogRefName].initBaseData()
            })
          }).finally(() => {
          })
        }
      } else if (CHARGE_CHANGE.code === documentProcess.documentConfigId) {
        getWorkFlowChangeCharge({ changeChargeUuid: documentProcess.docId }).then(async res => {
          workFlowApplyDialog.changeCharge = res.data
          workFlowApplyDialog.visible = true
        })
      } else if (COLLECT_INVOICE.code === documentProcess.documentConfigId) {
        // 发票ID 维度（开票单据）
        const requestBody = { 'keys': [documentProcess.docId] }
        getInvoiceDetails(requestBody).then(async res => {
          const invoiceProperties = workFlowApplyDialog.invoiceProperties
          invoiceProperties.invoices = res.data
          invoiceProperties.currentPage = 1
          invoiceProperties.totalPage = 1
          invoiceProperties.invoice = invoiceProperties.invoices[0]
          try {
            invoiceProperties.invoiceTriggerBpm = await WorkflowUtil.isBpmEnabled({ documentConfigId: COLLECT_INVOICE.code, officeId: this.$store.getters.currentOfficeId })
          } catch (e) {
            // error
          }
          workFlowApplyDialog.visible = true
          view.$nextTick(() => {
            view.$refs[workFlowApplyDialogRefName].initBaseData()
          })
        }).finally(() => {
        })
      }
    } finally {
      view.loading.close()
    }
  }

  static getWorkFlowCastByCode(code) {
    const isZh = $store.getters.language === 'zh'
    const position = Array.from(POSITION_CASTS).find(item => item.code === code)
    if (position) {
      return isZh ? position.chineseName : position.englishName
    }
    return isZh ? '未知岗位' : 'Unknown Position'
  }
}
